module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-toolbar', {
    staticClass: "primary elevation-0 small-extension",
    attrs: {
      "dark": ""
    }
  }, [_c('h1', {
    staticClass: "titulo"
  }, [_vm._v("Usuários")])]), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'UsuariosLista'
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Adicionar usuário")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticClass: "avatar",
    staticStyle: {
      "border-color": "#F37021",
      "width": "150px",
      "height": "150px",
      "display": "inline-block"
    },
    attrs: {
      "src": _vm.imageSrc
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "subheading secondary--text mt-2 mb-4",
    staticStyle: {
      "text-transform": "uppercase",
      "width": "100%",
      "float": "left",
      "cursor": "pointer"
    }
  }, [_vm._v("\n                Adicionar foto\n                "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "Nome",
      "name": "name",
      "data-vv-as": "nome",
      "error-messages": _vm.errors.has('name') ? _vm.errors.first('name') : []
    },
    model: {
      value: (_vm.form.fields.name),
      callback: function($$v) {
        _vm.form.fields.name = $$v
      },
      expression: "form.fields.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cargo"
    },
    model: {
      value: (_vm.form.fields.cargo),
      callback: function($$v) {
        _vm.form.fields.cargo = $$v
      },
      expression: "form.fields.cargo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: (['(##) ####-####', '(##) #####-####']),
      expression: "['(##) ####-####', '(##) #####-####']"
    }],
    attrs: {
      "label": "Celular"
    },
    model: {
      value: (_vm.form.fields.celular),
      callback: function($$v) {
        _vm.form.fields.celular = $$v
      },
      expression: "form.fields.celular"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Login")]), _c('br')]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "autocomplete": "off",
      "label": "E-mail",
      "name": "email",
      "data-vv-as": "email",
      "error-messages": _vm.errors.has('email') ? _vm.errors.first('email') : []
    },
    model: {
      value: (_vm.form.fields.email),
      callback: function($$v) {
        _vm.form.fields.email = $$v
      },
      expression: "form.fields.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "label": "Senha",
      "name": "password",
      "data-vv-as": "senha",
      "error-messages": _vm.errors.has('password') ? _vm.errors.first('password') : []
    },
    model: {
      value: (_vm.form.fields.password),
      callback: function($$v) {
        _vm.form.fields.password = $$v
      },
      expression: "form.fields.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('min:6|confirmed:password'),
      expression: "'min:6|confirmed:password'"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "password",
      "label": "Confirmar senha",
      "name": "conf_password",
      "data-vv-as": "confirmação de senha",
      "error-messages": _vm.errors.has('conf_password') ? _vm.errors.first('conf_password') : []
    },
    model: {
      value: (_vm.form.fields.conf_password),
      callback: function($$v) {
        _vm.form.fields.conf_password = $$v
      },
      expression: "form.fields.conf_password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.customRoles,
      "item-text": "name",
      "item-value": "id",
      "label": "Nível de acesso",
      "clearable": ""
    },
    model: {
      value: (_vm.form.fields.custom_role_id),
      callback: function($$v) {
        _vm.form.fields.custom_role_id = $$v
      },
      expression: "form.fields.custom_role_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "switch-fix",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Usuário "), (_vm.form.fields.bloqueado) ? _c('span', [_vm._v("bloqueado")]) : _c('span', [_vm._v("desbloqueado")])]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "color": "secondary",
      "hide-details": ""
    },
    model: {
      value: (_vm.form.fields.bloqueado),
      callback: function($$v) {
        _vm.form.fields.bloqueado = $$v
      },
      expression: "form.fields.bloqueado"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18cca2ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Usuarios/UsuariosAdicionar.vue
// module id = 991
// module chunks = 1